import(/* webpackMode: "eager" */ "/vercel/path0/app/word-counter/page.tsx");
